// extracted by mini-css-extract-plugin
export default {"fr-view":"ImageContainer_fr-view__wbowi","container":"ImageContainer_container__toCTi","wrapper":"ImageContainer_wrapper__bYP0V","image":"ImageContainer_image__U3Jyv"};